module.exports = __webpack_public_path__ + "img/tf.0d67cd70.svg";